import { render, staticRenderFns } from "./PageFiltering.vue?vue&type=template&id=319a3a0c&lang=pug&"
import script from "./PageFiltering.vue?vue&type=script&lang=js&"
export * from "./PageFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports